




























































































import { Component } from "vue-property-decorator";
import ClientDataSectionDialogComponent from "./ClientDataSectionDialog.vue";
import {
  ProjectDetails,
  RegulatorType,
} from "@/data/models/ProjectDetails";
import { localiseRegulatorType } from "@/utils/LocalisationHelper";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";

@Component({
  components: {
    "picker": PickerDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class RegulationSectionComponent extends ClientDataSectionDialogComponent {

  regulatorType: RegulatorType | null = null;

  private snapshotRegulatorType: RegulatorType | null = null;
  private snapshotFirstName = "";
  private snapshotLastName = "";
  private snapshotEmail = "";
  private snapshotPhone = "";
  private snapshotMobilePhone = "";

  regulatorOptions = [
    RegulatorType.VU_FIELD_SALES,
    RegulatorType.VU_INTERNAL_SALES,
    RegulatorType.EXTERNAL_REGULATOR,
    RegulatorType.AGENT,
    RegulatorType.VU_AGENCY,
  ];

  get regulatorTypeFormatter() {
    return (regulatorType: RegulatorType) => {
      return localiseRegulatorType(this, regulatorType);
    };
  }

  get hasEnteredRegulatorType() {
    return this.regulatorType;
  }

  hasInitialData(): boolean {
    const info = this.projectDetails.clientData.regulatorInfo;
    return !!(info.regulatorType || info.firstName || info.lastName || info.emailAddress || info.phone || info.mobilePhone);
  }

  takeSnapshot(): void {
    const info = this.projectDetails.clientData.regulatorInfo;
    this.snapshotRegulatorType = this.regulatorType;
    this.snapshotFirstName = info.firstName ?? "";
    this.snapshotLastName = info.lastName ?? "";
    this.snapshotEmail = info.emailAddress ?? "";
    this.snapshotPhone = info.phone ?? "";
    this.snapshotMobilePhone = info.mobilePhone ?? "";
  }

  get hasChanged(): boolean {
    const info = this.projectDetails.clientData.regulatorInfo;
    return this.regulatorType !== this.snapshotRegulatorType
      || (info.firstName ?? "") !== this.snapshotFirstName
      || (info.lastName ?? "") !== this.snapshotLastName
      || (info.emailAddress ?? "") !== this.snapshotEmail
      || (info.phone ?? "") !== this.snapshotPhone
      || (info.mobilePhone ?? "") !== this.snapshotMobilePhone;
  }

  onAccept() {
    this.isShowing = false;
    this.projectDetails.clientData.regulatorInfo.regulatorType = this.regulatorType;

    this.resolve && this.resolve(this.projectDetails);
  }

  async show(projectDetails: ProjectDetails) {
    if (projectDetails.clientData.regulatorInfo.regulatorType) {
      this.regulatorType = projectDetails.clientData.regulatorInfo.regulatorType;
    }

    return this.showDialog(
      this.$t("clientData.regulation").toString(),
      projectDetails
    );
  }
}
